import Vue from 'vue'

// const req = require.context('./', true, /\.(js|vue)$/i)
//
// req.keys().map(key => {
//   const name = key.match(/\w+/)[0]
//   return Vue.component(name, req(key))
// })

import Icon from './Icon';

Vue.component('icon', Icon);
